<template>
    <nav>
        <router-link :to="{ name: 'home' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span class="menu-sidebar-label">Home</span>
        </router-link>
        <router-link :to="{ name: 'patients' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span class="menu-sidebar-label">Pacientes</span>
        </router-link>
        <router-link :to="{ name: 'evaluations' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V19a2 2 0 01-2 2Z" />
            </svg>
            <span class="menu-sidebar-label">Avaliações</span>
        </router-link>
        <router-link :to="{ name: 'usageLimits' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
            </svg>
            <span class="menu-sidebar-label">Uso de IA</span>
        </router-link>
        <router-link :to="{ name: 'account' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span class="menu-sidebar-label">Minha Conta</span>
        </router-link>
        <router-link :to="{ name: 'subscription' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <span class="menu-sidebar-label">Assinatura</span>
        </router-link>
        <router-link v-if="isAdmin" :to="{ name: 'users' }" class="menu-sidebar-item">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span class="menu-sidebar-label">Usuários</span>
        </router-link>
        <button type="button" @click="logout" class="menu-sidebar-item w-full text-left">
            <svg xmlns="http://www.w3.org/2000/svg" class="menu-sidebar-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span class="menu-sidebar-label">Sair</span>
        </button>

        <div class="mt-4">
            <SidebarUsage />
        </div>
    </nav>
</template>

<script>
import { ref, onMounted } from 'vue';
import AuthService from '../services/AuthService';
import SidebarUsage from './SidebarUsage.vue';

export default {
    name: 'SidebarNav',
    components: { SidebarUsage },
    setup() {
        const isAdmin = ref(false);

        onMounted(() => {
            isAdmin.value = AuthService.isOwnerOrAdmin();
        });

        function logout() {
            AuthService.logout();
        }

        return { isAdmin, logout };
    }
}
</script>
